import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

import Home from './views/Home';
import Header from './components/Header';
import Technology from './views/Technology';
import Contact from './views/Contact';
import Studies from './views/Studies';

import './styles/all.css';

function App() {
  return (
    <div>
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/technology" element={<Technology />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/studies" element={<Studies />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
